// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.M8rz3WFdm66fdg {
  margin-top: var(--ds-space-150, 12px);
}
.K6hxONY_n15HyS {
  margin-top: var(--ds-space-200, 16px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  font-weight: var(--ds-font-weight-semibold, 600);
}
.pthawP6HEfB34Y {
  display: flex;
  flex-direction: column;
}
.FencATae2UNOtd {
  position: relative;
  min-height: 16px;
  margin: var(--ds-space-050, 4px) var(--ds-space-100, 8px);
  padding: var(--ds-space-0, 0);
  font-size: 14px;
  font-weight: var(--ds-font-weight-regular, 400);
}
._zuMQT5LDymvSk {
  color: var(--ds-text, #172b4d);
  font: var(--ds-font-body, 400 14px / 20px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-display: swap;
  padding: 8px 12px;
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
  border: none;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
  display: block;
  box-sizing: border-box;
  width: 100%;
  margin-top: var(--ds-space-100, 8px);
  padding: var(--ds-space-100, 8px) var(--ds-space-150, 12px);
  overflow: hidden;
  overflow-wrap: break-word;
  border-radius: var(--ds-border-radius-100, 3px);
  outline: none;
  resize: none;
}
._zuMQT5LDymvSk:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
}
._zuMQT5LDymvSk:focus {
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
._zuMQT5LDymvSk:disabled {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: none;
  color: var(--ds-text-disabled, #091e424f);
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
._zuMQT5LDymvSk[readonly] {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: inset 0 0 0 2px var(--ds-border-input, #091e4224);
}
._zuMQT5LDymvSk.aF1cS5NGOb89CC {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
._zuMQT5LDymvSk.aF1cS5NGOb89CC:hover {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
._zuMQT5LDymvSk.aF1cS5NGOb89CC:focus {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
._zuMQT5LDymvSk.tj_gYMe6Fn4Etb {
  width: 100%;
}
._zuMQT5LDymvSk::placeholder {
  color: var(--ds-text-subtlest, #626f86);
}
`, ""]);
// Exports
export var popoverSection = `M8rz3WFdm66fdg`;
export var header = `K6hxONY_n15HyS`;
export var keepChecklist = `pthawP6HEfB34Y`;
export var checklistItem = `FencATae2UNOtd`;
export var titleEditor = `_zuMQT5LDymvSk`;
var _1 = `aF1cS5NGOb89CC`;
export { _1 as "input-error" };
export var full = `tj_gYMe6Fn4Etb`;
export default ___CSS_LOADER_EXPORT___;
